/**
 * Composant de base pour les skeletons
 * Fournit une animation de chargement réutilisable
 */

export default function SkeletonBase({ 
  className = "", 
  width = "100%", 
  height = "1rem",
  rounded = "rounded"
}) {
  return (
    <div
      className={`bg-gray-200 animate-pulse ${rounded} ${className}`}
      style={{ width, height }}
    />
  )
}
